// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import {transformValueFloattoFormated,MaskOnlyNumbers} from "beaktShared/helpers/masks";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { SessionContext } from "beaktShared/services/session";
import { UsePostApi } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

export default function CancelamentoBeakt({ detalheVenda, CallbackGestaoPedidos }) {
  const classes = useStyles();

  const session = useContext(SessionContext);
  const { register, errors, handleSubmit} = useForm({mode: "onBlur"}); 
  
  useEffect(() => {  
    loadCards();
  }, []);
  
  const [alert,setalert] = React.useState();
  const showAlert = (message, tipo) => {        
      setalert(<SweetAlert
        error={tipo==='error'?true:false}
        warning={tipo==='warning'?true:false}
        success={tipo==='success'?true:false}
        title="Aviso"
        onConfirm={() => 
            { tipo==='success' ? CallbackGestaoPedidos() : setalert(null) }}
      >  
      <div dangerouslySetInnerHTML={{ __html: message}} /> 
      </SweetAlert> );
  };

  const [LoadingForm,setLoadingForm]= React.useState(false);

  const [cards, setcards] = React.useState([]);
  const loadCards = () => {
    let cartoes = [];
    detalheVenda.vendaGestaoPagamentos.filter((f) => f.gateway === "Beakt Crédito ESitef").map(item => {    
            cartoes.push({
                host_usn: item.numAutorizacao,
                amount: item.valor.toFixed(2).toString().replace(",", "").replace(".", ""),
                card: {
                    security_code: "",
                    number: "",
                    expiry_date: ""
                }
            });         
    });
    setcards(cartoes);
  }
  const handleCardsChange = (idx,field,value) => {
      let updatecards = [...cards];
      updatecards[idx].card[field] = value;      
      setcards(updatecards);
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    
    var dadospost = {
        cards: cards
    }

    let endpoint = "CancelamentoPagamentoBeakt/CancelarPagamentoBeaktEsitef/" + detalheVenda.vendaId + "/" + session.id;
    setLoadingForm(true);
    UsePostApi(endpoint, dadospost).then(result => {
        setLoadingForm(false);
        if (result.status !== 200) {
            showAlert(result.message, "error");
            return false;
        }
        if (result.data.sucesso === false){
            showAlert(result.data.mensagem, "error");
            return false;
        }
        
        let mensagem = result.data.mensagem;
        let mensagem_autorizadora = "";
        if (result.data.transacoes_cancelamento != null)
        {
            for(var i in result.data.transacoes_cancelamento){
                mensagem_autorizadora += "<br/>" + result.data.transacoes_cancelamento[i].mensagem_autorizadora;
            }
        }

        if (result.data.transacoes_cancelamento.filter((f) => f.sucesso === false).length > 0)
            mensagem += "<br/><br/>Não foi possível cancelar todos os cartões. Entre em contato com a Administradora do Cartão e solicite o cancelameto. <br/>" + mensagem_autorizadora        
        else
            mensagem += mensagem_autorizadora;
        
        showAlert(mensagem, "success");
    });
  }

return (
    <form onSubmit={handleSubmit(onSubmit)}>    
        <GridContainer>
             {LoadingForm && 
                <div className="carregandoCmp">
                    <div className="box">
                        <label>Carregando...</label>
                        <CircularProgress />
                    </div>
                </div> 
            }
            {alert}
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <HighlightOffIcon />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>Cancelamento de Transações Beakt</h4>
                    </CardHeader>
                    <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={1}>
                                    <label><b>Venda</b><br/> {detalheVenda.vendaId}</label>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <label><b>Cliente</b><br/> {detalheVenda.clienteNome}</label>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <label><b>Usuário</b><br/> {detalheVenda.usuarioNome}</label>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <label><b>Status Venda</b><br/> {detalheVenda.statusVendaDesc}</label>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <label><b>Valor Total</b><br/> {transformValueFloattoFormated(detalheVenda.totalVenda)}</label>
                                </GridItem>
                            </GridContainer>                            
                            {detalheVenda.vendaGestaoPagamentos.filter((f) => f.gateway === "Beakt Crédito ESitef").map((item, index) => (                                
                                <div key={item.numAutorizacao}>
                                    <br/>
                                    <div className="subTitulo"> 
                                        <h6>{item.detalhe}</h6>
                                    </div>
                                    <GridContainer>        
                                        <GridItem xs={12} sm={6} md={5}>                                        
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{shrink: true}} 
                                                defaultValue=""  
                                                name="number"    
                                                label="* Número do Cartão"  
                                                inputProps={{maxLength: 16}}   
                                                onInput={(e) => MaskOnlyNumbers(e) }             
                                                onBlur={(e) => handleCardsChange(index, "number", e.target.value)}
                                                inputRef={register({required: true})}
                                                error={errors.number?true:false} 
                                            />
                                            <FormHelperText>
                                                {errors.number && <span className="obg">Obrigatório</span>}
                                            </FormHelperText>   
                                        </GridItem>
                                        <GridItem xs={12} sm={4} md={3}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                onInput={(e) => MaskOnlyNumbers(e) }             
                                                InputLabelProps={{shrink: true}} 
                                                defaultValue="" 
                                                placeholder="MMAA"    
                                                name="expiry_date"  
                                                label="* Validade"
                                                inputProps={{maxLength: 4}}
                                                onBlur={(e) => handleCardsChange(index, "expiry_date", e.target.value)}
                                                inputRef={register({required: true})}
                                                error={errors.expiry_date?true:false} 
                                            />
                                            <FormHelperText>
                                                {errors.expiry_date && <span className="obg">Obrigatório</span>}
                                            </FormHelperText>   
                                        </GridItem>
                                        <GridItem xs={12} sm={3} md={2}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                onInput={(e) => MaskOnlyNumbers(e) }             
                                                InputLabelProps={{shrink: true}} 
                                                defaultValue="" 
                                                name="security_code"    
                                                label="* CVV"   
                                                inputProps={{maxLength: 3}}                                                   
                                                onBlur={(e) => handleCardsChange(index, "security_code", e.target.value)}
                                                inputRef={register({required: true})}
                                                error={errors.security_code?true:false} 
                                            />
                                            <FormHelperText>
                                                {errors.security_code && <span className="obg">Obrigatório</span>}
                                            </FormHelperText>   
                                        </GridItem> 
                                        <GridItem xs={12} sm={3} md={2}>
                                            <TextField
                                                disabled={true}
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{shrink: true}}
                                                name="valor"    
                                                label="Valor"   
                                                value={transformValueFloattoFormated(item.valor)}
                                            />                                            
                                        </GridItem> 
                                    </GridContainer>
                                </div>                                
                            ))}
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <center>
            <br/>
            <div className={classes.textCenter}>
                <Button  onClick={() => CallbackGestaoPedidos()} color="transparent" className={classes.updateProfileButton}>
                    Voltar
                </Button>
                <Button type="submit" color="info" className={classes.updateProfileButton}>
                    Confirmar Cancelamento
                </Button>
            </div>
            
        </center>            
    </form>
);
}